import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import StandardAppBar from '../StandardAppBar';
import DashboardApplications from './DashboardApplications';
import DashboardManager from './DashboardManager';

class DashboardApplication extends Component {

  render() {

    return (
      <React.Fragment>
        <Switch>
          <Route exact path="/dashboard" render={
            (props) => <DashboardApplications {...props} appBar={<StandardAppBar title="Dashboard" />} />} />
          <Route path={"/dashboard/*"} render={
            (props) => <DashboardManager {...props} />} />
        </Switch>
      </React.Fragment>
    );
  }
}

export default DashboardApplication;
